(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/mini/views/playnowbutton.js') >= 0) return;  svs.modules.push('/components/statistics/mini/views/playnowbutton.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.statistics=_svs.statistics||{};
_svs.statistics.mini=_svs.statistics.mini||{};
_svs.statistics.mini.templates=_svs.statistics.mini.templates||{};
svs.statistics.mini.templates.playnowbutton = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "Spela direkt<span class=\"play-objects\">+"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.oddsetDraws : depth0)) != null ? stack1.eventCount : stack1), depth0))
    + "</span> ";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"mini-play-now statistics-element clearfix\">\n  "
    + ((stack1 = (helpers.ui || (depth0 && depth0.ui) || helpers.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"button",{"name":"ui","hash":{"class":"btn-play-now js-first-play-stat js-clickable-ignore","block":true,"size":300},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n</div>\n";
},"useData":true});
Handlebars.partials['components-statistics-mini-playnowbutton'] = svs.statistics.mini.templates.playnowbutton;
})(svs, Handlebars);

 })(window);